module.exports = __webpack_public_path__ + "img/empty-image-default.66614a8f.png";